<template>
    <div class="py-4 container-fluid">
        <!-- KPI Stats Cards -->
        <div class="row mb-4">
            <div class="col-xl-3 col-sm-6 mb-xl-0 mb-3">
                <div class="card">
                    <div class="card-body p-3">
                        <div class="d-flex align-items-center">
                            <div class="pqr-stat-icon bg-gradient-primary">
                                <i class="fas fa-clipboard-list text-white"></i>
                            </div>
                            <div class="ms-3">
                                <p class="text-sm mb-0 font-weight-bold text-secondary">Total PQR</p>
                                <h4 class="mb-0 font-weight-bolder">{{ pqrs.total || 0 }}</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-3 col-sm-6 mb-xl-0 mb-3">
                <div class="card">
                    <div class="card-body p-3">
                        <div class="d-flex align-items-center">
                            <div class="pqr-stat-icon bg-gradient-info">
                                <i class="fas fa-folder-open text-white"></i>
                            </div>
                            <div class="ms-3">
                                <p class="text-sm mb-0 font-weight-bold text-secondary">Abiertos</p>
                                <h4 class="mb-0 font-weight-bolder">{{ countByEstado('abierto') }}</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-3 col-sm-6 mb-xl-0 mb-3">
                <div class="card">
                    <div class="card-body p-3">
                        <div class="d-flex align-items-center">
                            <div class="pqr-stat-icon bg-gradient-warning">
                                <i class="fas fa-clock text-white"></i>
                            </div>
                            <div class="ms-3">
                                <p class="text-sm mb-0 font-weight-bold text-secondary">En Revisión</p>
                                <h4 class="mb-0 font-weight-bolder">{{ countByEstado('en_revision') }}</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-3 col-sm-6 mb-xl-0 mb-3">
                <div class="card">
                    <div class="card-body p-3">
                        <div class="d-flex align-items-center">
                            <div class="pqr-stat-icon bg-gradient-success">
                                <i class="fas fa-check-circle text-white"></i>
                            </div>
                            <div class="ms-3">
                                <p class="text-sm mb-0 font-weight-bold text-secondary">Resueltos</p>
                                <h4 class="mb-0 font-weight-bolder">{{ countByEstado('resuelto') }}</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- PQR Table -->
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header pb-0">
                        <!-- Title row -->
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <div>
                                <h6 class="mb-0 font-weight-bolder">Gestión de PQR</h6>
                                <p class="text-xs text-secondary mb-0">Peticiones, Quejas y Reclamos</p>
                            </div>
                            <div class="d-flex gap-2 align-items-center">
                                <span class="badge bg-light text-dark border px-3 py-2">
                                    <i class="fas fa-list-ol me-1 text-secondary"></i>
                                    {{ pqrs.total || 0 }} registros
                                </span>
                                <soft-button variant="outline" color="secondary" size="sm"
                                    @click="getPQRs(1)" :loading="spinner">
                                    <i class="fas fa-sync-alt me-1"></i>
                                    Actualizar
                                </soft-button>
                            </div>
                        </div>

                        <!-- Filters -->
                        <div class="filters-container">
                            <div class="row align-items-end g-3">
                                <div class="col-12 col-lg-4">
                                    <label class="form-label fw-semibold text-xs">
                                        <i class="fas fa-search text-secondary me-1"></i> Buscar
                                    </label>
                                    <input
                                        v-model="filter.search"
                                        type="text"
                                        class="form-control form-control-sm"
                                        placeholder="Buscar por asunto..."
                                        @keyup.enter="getPQRs(1)"
                                    />
                                </div>
                                <div class="col-6 col-lg-2">
                                    <label class="form-label fw-semibold text-xs">
                                        <i class="fas fa-tag text-secondary me-1"></i> Categoría
                                    </label>
                                    <v-select
                                        v-model="filter.categoria"
                                        :options="categoriaOptions"
                                        :clearable="true"
                                        placeholder="Todas"
                                        label="label"
                                        class="pqr-select"
                                    />
                                </div>
                                <div class="col-6 col-lg-2">
                                    <label class="form-label fw-semibold text-xs">
                                        <i class="fas fa-flag text-secondary me-1"></i> Estado
                                    </label>
                                    <v-select
                                        v-model="filter.estado"
                                        :options="estadoOptions"
                                        :clearable="true"
                                        placeholder="Todos"
                                        label="label"
                                        class="pqr-select"
                                    />
                                </div>
                                <div class="col-6 col-lg-2">
                                    <label class="form-label fw-semibold text-xs">
                                        <i class="fas fa-exclamation-circle text-secondary me-1"></i> Prioridad
                                    </label>
                                    <v-select
                                        v-model="filter.prioridad"
                                        :options="prioridadOptions"
                                        :clearable="true"
                                        placeholder="Todas"
                                        label="label"
                                        class="pqr-select"
                                    />
                                </div>
                                <div class="col-6 col-lg-2">
                                    <div class="d-flex gap-2">
                                        <soft-button variant="gradient" size="sm" class="w-100"
                                            @click="getPQRs(1)">
                                            <i class="fas fa-search me-1"></i> Buscar
                                        </soft-button>
                                        <soft-button variant="outline" color="secondary" size="sm"
                                            @click="clearFilters" title="Limpiar filtros">
                                            <i class="fas fa-broom"></i>
                                        </soft-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card-body px-0 pt-0 pb-2">
                        <div class="table-responsive p-0">
                            <soft-spinner v-if="spinner" />
                            <table v-else class="table align-items-center mb-0">
                                <thead>
                                    <tr>
                                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">ID</th>
                                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Asunto</th>
                                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Categoría</th>
                                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Prioridad</th>
                                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Estado</th>
                                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Solicitante</th>
                                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Fecha</th>
                                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2 text-center">Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="!pqrs.data || pqrs.data.length === 0">
                                        <td colspan="8" class="text-center py-5">
                                            <i class="fas fa-inbox text-secondary mb-2 d-block" style="font-size: 2rem; opacity: 0.4;"></i>
                                            <span class="text-secondary text-sm">No se encontraron registros</span>
                                        </td>
                                    </tr>
                                    <tr v-for="item in pqrs.data" :key="item.id">
                                        <!-- ID -->
                                        <td>
                                            <div class="d-flex px-2 py-1">
                                                <span class="text-xs font-weight-bold text-primary">#{{ item.id }}</span>
                                            </div>
                                        </td>
                                        <!-- Asunto -->
                                        <td>
                                            <p class="text-sm font-weight-bold mb-0 text-dark pqr-asunto">{{ item.asunto }}</p>
                                        </td>
                                        <!-- Categoría -->
                                        <td>
                                            <soft-badge
                                                :color="getCategoriaColor(item.categoria)"
                                                variant="gradient"
                                                size="sm"
                                            >
                                                <i :class="getCategoriaIcon(item.categoria)" class="me-1"></i>
                                                {{ formatCategoria(item.categoria) }}
                                            </soft-badge>
                                        </td>
                                        <!-- Prioridad -->
                                        <td>
                                            <div class="d-flex align-items-center">
                                                <span class="pqr-priority-dot" :class="'priority-' + item.prioridad"></span>
                                                <span class="text-xs font-weight-bold text-capitalize">{{ item.prioridad }}</span>
                                            </div>
                                        </td>
                                        <!-- Estado -->
                                        <td>
                                            <soft-badge
                                                :color="getEstadoColor(item.estado)"
                                                variant="gradient"
                                                size="sm"
                                            >
                                                {{ formatEstado(item.estado) }}
                                            </soft-badge>
                                        </td>
                                        <!-- Solicitante -->
                                        <td>
                                            <div class="d-flex align-items-center py-1">
                                                <div class="pqr-avatar bg-gradient-secondary">
                                                    <span class="text-white text-xxs font-weight-bold">
                                                        {{ getInitials(item.user) }}
                                                    </span>
                                                </div>
                                                <div class="ms-2">
                                                    <p class="text-xs font-weight-bold mb-0">
                                                        {{ item.user?.userdata_info?.primer_nombre }} {{ item.user?.userdata_info?.primer_apellido }}
                                                    </p>
                                                    <p class="text-xxs text-secondary mb-0">{{ item.user?.email }}</p>
                                                </div>
                                            </div>
                                        </td>
                                        <!-- Fecha -->
                                        <td>
                                            <p class="text-xs font-weight-bold mb-0">{{ formatDateShort(item.created_at) }}</p>
                                            <p class="text-xxs text-secondary mb-0">{{ formatTime(item.created_at) }}</p>
                                        </td>
                                        <!-- Acciones -->
                                        <td class="text-center">
                                            <div class="d-flex justify-content-center gap-1">
                                                <router-link
                                                    :to="{ name: 'PQRDetail', params: { id: item.id } }"
                                                    class="table-action-link"
                                                    title="Ver detalle"
                                                >
                                                    <i class="fas fa-eye"></i>
                                                </router-link>
                                                <a href="#"
                                                    class="table-action-link text-danger"
                                                    @click.prevent="confirmDelete(item.id)"
                                                    title="Eliminar"
                                                >
                                                    <i class="fas fa-trash"></i>
                                                </a>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <!-- Pagination -->
                        <div v-if="pqrs.last_page > 1" class="d-flex justify-content-between align-items-center px-3 py-3 border-top">
                            <small class="text-secondary text-xs">
                                Página {{ pqrs.current_page }} de {{ pqrs.last_page }}
                            </small>
                            <base-pagination
                                :current-page="pqrs.current_page"
                                :page-count="pqrs.last_page"
                                @nextPage="getPQRs(pqrs.current_page + 1)"
                                @previousPage="getPQRs(pqrs.current_page - 1)"
                                @loadPage="getPQRs"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Delete Confirmation Modal -->
        <soft-modal
            @close="closeDeleteConfirm"
            :modalActive="showDeleteConfirm"
            v-if="showDeleteConfirm"
            size="sm"
        >
            <div class="text-center p-3">
                <div class="pqr-delete-icon mx-auto mb-3">
                    <i class="fas fa-exclamation-triangle text-danger" style="font-size: 1.75rem;"></i>
                </div>
                <h5 class="font-weight-bolder mb-2">Confirmar Eliminación</h5>
                <p class="text-sm text-secondary mb-4">
                    Esta acción es irreversible. El registro PQR será eliminado permanentemente.
                </p>
                <div class="d-flex gap-2 justify-content-center">
                    <soft-button variant="outline" color="secondary" size="sm"
                        @click="closeDeleteConfirm">
                        Cancelar
                    </soft-button>
                    <soft-button variant="gradient" color="danger" size="sm"
                        @click="executeDelete" :loading="spinner">
                        <i class="fas fa-trash me-1"></i>
                        Eliminar
                    </soft-button>
                </div>
            </div>
        </soft-modal>
    </div>
</template>

<script>
import SoftButton from "@/components/SoftButton.vue";
import SoftBadge from "@/components/SoftBadge.vue";
import SoftModal from "@/components/SoftModal.vue";
import SoftSpinner from "@/components/SoftSpinner.vue";
import BasePagination from "@/components/pagination/BasePagination.vue";
import { usePQR } from "./usePQR.js";

export default {
    name: "PQRManagement",
    components: {
        SoftButton,
        SoftBadge,
        SoftModal,
        SoftSpinner,
        BasePagination,
    },
    setup() {
        const {
            headers, getPQRs, pqrs, spinner, filter,
            showDeleteConfirm, closeDeleteConfirm, confirmDelete, executeDelete,
            categoriaOptions, estadoOptions, prioridadOptions,
        } = usePQR();

        getPQRs();

        const clearFilters = () => {
            filter.value = { categoria: null, estado: null, prioridad: null, search: null, per_page: 15 };
            getPQRs(1);
        };

        const countByEstado = (estado) => {
            if (!pqrs.value.data) return 0;
            return pqrs.value.data.filter(p => p.estado === estado).length;
        };

        const getInitials = (user) => {
            if (!user?.userdata_info) return '?';
            const first = user.userdata_info.primer_nombre?.[0] || '';
            const last = user.userdata_info.primer_apellido?.[0] || '';
            return (first + last).toUpperCase();
        };

        const getCategoriaColor = (categoria) => {
            const colors = { soporte_tecnico: 'info', solicitud_administrativa: 'warning', sugerencias_de_mejora: 'success' };
            return colors[categoria] || 'secondary';
        };

        const getCategoriaIcon = (categoria) => {
            const icons = { soporte_tecnico: 'fas fa-headset', solicitud_administrativa: 'fas fa-file-alt', sugerencias_de_mejora: 'fas fa-lightbulb' };
            return icons[categoria] || 'fas fa-tag';
        };

        const formatCategoria = (categoria) => {
            const labels = { soporte_tecnico: 'Soporte Técnico', solicitud_administrativa: 'Administrativa', sugerencias_de_mejora: 'Mejora' };
            return labels[categoria] || categoria;
        };

        const formatEstado = (estado) => {
            const labels = { abierto: 'Abierto', en_revision: 'En Revisión', resuelto: 'Resuelto', cerrado: 'Cerrado' };
            return labels[estado] || estado;
        };

        const getPrioridadColorRaw = (prioridad) => {
            const colors = { alta: 'danger', media: 'warning', baja: 'success' };
            return colors[prioridad] || 'secondary';
        };

        const getEstadoColor = (estado) => {
            const colors = { abierto: 'info', en_revision: 'warning', resuelto: 'success', cerrado: 'secondary' };
            return colors[estado] || 'secondary';
        };

        const formatDateShort = (date) => {
            if (!date) return '—';
            return new Date(date).toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' });
        };

        const formatTime = (date) => {
            if (!date) return '';
            return new Date(date).toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
        };

        return {
            headers, getPQRs, pqrs, spinner, filter,
            showDeleteConfirm, closeDeleteConfirm, confirmDelete, executeDelete,
            categoriaOptions, estadoOptions, prioridadOptions,
            clearFilters, countByEstado, getInitials,
            getCategoriaColor, getCategoriaIcon, formatCategoria,
            formatEstado, getPrioridadColorRaw, getEstadoColor,
            formatDateShort, formatTime,
        };
    },
};
</script>

<style lang="scss" scoped>
.pqr-stat-icon {
    width: 48px;
    height: 48px;
    border-radius: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1rem;
    flex-shrink: 0;
}

.pqr-avatar {
    width: 32px;
    height: 32px;
    border-radius: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.pqr-priority-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: inline-block;
    margin-right: 8px;
    flex-shrink: 0;

    &.priority-alta { background-color: #ea0606; }
    &.priority-media { background-color: #fbcf33; }
    &.priority-baja { background-color: #82d616; }
}

.pqr-asunto {
    max-width: 220px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.pqr-delete-icon {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: #fef2f2;
    display: flex;
    align-items: center;
    justify-content: center;
}

.table-action-link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border-radius: 0.375rem;
    color: #8392AB;
    transition: all 0.15s ease;
    text-decoration: none;

    &:hover {
        background-color: #f0f2f5;
        color: #344767;
    }

    &.text-danger:hover {
        background-color: #fef2f2;
        color: #ea0606;
    }
}

// Filters
.filters-container {
    background: #f8f9fa;
    border-radius: 0.75rem;
    padding: 1rem;
    margin-top: 0.5rem;

    .form-label {
        margin-bottom: 0.4rem;
        color: #344767;
    }
}

// Vue-Select
.pqr-select {
    :deep(.vs__dropdown-toggle) {
        border: 1px solid #d2d6da;
        border-radius: 0.5rem;
        min-height: 36px;
        background: #fff;
    }

    :deep(.vs__dropdown-toggle:focus-within) {
        border-color: #ef9a9a;
        box-shadow: 0 0 0 2px rgba(229, 57, 53, 0.12);
    }

    :deep(.vs__dropdown-option--highlight) {
        background: #E53935;
        color: #fff;
    }
}

// Focus colors
.form-control:focus {
    border-color: #ef9a9a;
    box-shadow: 0 0 0 2px rgba(229, 57, 53, 0.12);
}
</style>
